export const UsersTableHeader = [
  { title: 'ID', width: 'w-[50px]' },
  { title: 'ФИО' },
  { title: 'e-mail' },
  { title: 'Телефон' },
  { title: 'Место работы' },
];
